<template>
    <div class="shareRes">
        <div class="shareResBox Center">
          <div class="box">
            <img src="../assets/draw/2.png" class="wid100">
            <div class="shareResBody">
              <div class="claimed-info">
                <p class="claimed-text" >您已分享成功获得一次抽奖机会</p>
                <p class="claimed-text result-highlight">返回首页即可抽奖</p>
              </div>

              <div class="close-btn">
                <img src="../assets/btn/home.png" @click="handleClose" alt="返回首页">
              </div>
            </div>
          </div>

        </div>
    </div>
</template>

<script>
export default {
  name: "shareRes",
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
  .shareRes{width: 100%; height: 100%; overflow-y: auto; position: absolute; z-index: 12; top:0; left: 0; background: rgba(0,0,0,0.8)}
  .shareRes .shareResBox{width: 100%; height: 90%; text-align: right}
  .shareRes .shareResBox .box{width: 90%; position: relative}
  .shareRes .shareResBody{width: 100%;height: 100%; position: absolute; top:0;}
  .shareRes .shareResBody .claimed-info{  position: absolute;top:12%;left: 0;width: 100%;text-align: center;}
  .shareRes .shareResBody .claimed-text{    font-size: 1rem;
    color: #381d06;
    line-height: 1.2;}
  .shareRes .shareResBody .result-highlight {
    font-weight: bold;
    background-image: linear-gradient(to bottom, #2c1504, #e43e1d);
    -webkit-background-clip: text;
    color: transparent;
    /* 抗锯齿和增强文字边缘 */
    -webkit-font-smoothing: antialiased;
    font-size: 1.8rem;
    margin-top: 2%;
  }

  /* 关闭按钮 */
  .close-btn {
    position: absolute;
    bottom: -10%;
    width: 100%;
    z-index: 10;
    text-align: center;
    cursor: none;
  }

  .close-btn img {
    width: 50%;
  }

</style>



// WEBPACK FOOTER //
// src/components/shareRes.vue